import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/web-targets/',
)({
  component: WebTargetsRoute,
});

function WebTargetsRoute() {
  const { groupName } = Route.useParams();

  return (
    <Navigate
      to="/groups/$groupName/follow-ups/follow-up-requests/"
      params={{ groupName }}
    />
  );
}
